export default __webpack_public_path__ + "static/media/opencv.1bc26191.png";